import { createFileRoute } from "@tanstack/react-router";
import UnderConstruction from "@/components/common/UnderConstruction";

export const Route = createFileRoute("/_app/ventes/crm/create")({
  staticData: {
    title: "Nouveau contact",
    showInBreadcrumb: true,
  },
  component: UnderConstruction,
});
